


















import { Vue, Component } from 'vue-property-decorator';

// This component renders a bilingual message for payment callback pages
// and switches content based on action: "return" (success callback) or "cancel".
// It detects the current language from Vue i18n (ru/en).

@Component({})
export default class UntitledPaymentCallback extends Vue {
  // Determine action mode from route (query, params, or path fallback)
  get action(): 'success' | 'cancel' {
    const q = (this.$route && this.$route.query && (this.$route.query as any).action) || '';
    const p = (this.$route && this.$route.params && (this.$route.params as any).action) || '';
    const cand = String(q || p || '').toLowerCase();
    if (cand === 'cancel') return 'cancel';
    if (cand === 'success') return 'success';

    const path = (this.$route && this.$route.path ? this.$route.path : window.location.pathname).toLowerCase();
    if (path.includes('cancel')) return 'cancel';
    // treat everything else as return
    return 'success';
  }

  // Current locale detection (default to en)
  get isRu(): boolean {
    const loc = (this as any).$i18n && (this as any).$i18n.locale ? String((this as any).$i18n.locale).toLowerCase() : 'en';
    return loc.startsWith('ru');
  }

  // Section labels
  get whatsNextLabel(): string {
    return this.isRu ? 'Что дальше:' : "What’s next:";
  }

  get needHelpLabel(): string {
    return this.isRu ? 'Если нужна помощь:' : 'Need help:';
  }

  // Texts for RETURN action
  get titleReturn(): string {
    return this.isRu ? 'Подтверждение получено' : 'Confirmation received';
  }

  get mainTextReturn(): string {
    return this.isRu
      ? 'Мы получили ответ от платёжной системы. Итоговый статус операции будет подтверждён после обработки уведомления.'
      : 'We received a response from the payment provider. The final status will be confirmed after processing the notification.';
  }

  get whatsNextReturn(): string {
    return this.isRu
      ? 'Эту страницу можно закрыть. Если вы получили ссылку на оплату от нашего менеджера, дополнительных действий не требуется — при необходимости мы свяжемся с вами.'
      : 'You can close this page. If you received the payment link from our manager, no further action is required — we will contact you if needed.';
  }

  get needHelpReturn(): string {
    return this.isRu
      ? 'Напишите нам и укажите дату/время операции и email, который вы использовали в PayPal.'
      : 'Please message us and include the date/time of the transaction and the email you used in PayPal.';
  }

  // Texts for CANCEL action
  get titleCancel(): string {
    return this.isRu ? 'Операция не завершена' : 'Action not completed';
  }

  get mainTextCancel(): string {
    return this.isRu
      ? 'Подтверждение в платёжной системе было отменено или не завершено.'
      : 'The payment confirmation was canceled or not completed.';
  }

  get whatsNextCancel(): string {
    return this.isRu
      ? 'Если вы хотите продолжить, откройте ссылку на оплату ещё раз или запросите новую у менеджера.'
      : 'If you’d like to continue, open the payment link again or request a new one from our manager.';
  }

  get needHelpCancel(): string {
    return this.isRu
      ? 'Напишите нам и укажите дату/время попытки и email, который вы использовали в PayPal (если вводили).'
      : 'Please message us and include the date/time of the attempt and the email you used in PayPal (if provided).';
  }

  // Public getters used by template
  get title(): string {
    return this.action === 'cancel' ? this.titleCancel : this.titleReturn;
  }

  get mainText(): string {
    return this.action === 'cancel' ? this.mainTextCancel : this.mainTextReturn;
  }

  get whatsNext(): string {
    return this.action === 'cancel' ? this.whatsNextCancel : this.whatsNextReturn;
  }

  get needHelp(): string {
    return this.action === 'cancel' ? this.needHelpCancel : this.needHelpReturn;
  }
}
